import React from 'react';
import { tracer } from './services/telemetry/otel';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './assets/styles.css';
import './assets/fonts.css';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import { initPostHog } from './services/posthog/init';
import { log } from '@domgen/shared/utils/log';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const renderApp = () => {
  createRoot(container).render(
    <React.StrictMode>
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </React.StrictMode>,
  );
};

const bootstrap = async () => {
  await initPostHog({
    brand: import.meta.env.VITE_BRAND_CODE,
  }).catch((e) => log.info({ message: 'Error initializing PostHog', data: e }));
  renderApp();
};

bootstrap();
if (typeof window !== 'undefined') {
  tracer();
}
